import { PostMedia } from '@/features/(insight)/posts/ui/social-post-card/post-media';

import type { Post } from '@/entities/post/types';
import { getPlatformLogo } from '@/entities/public-filter/constants';

export const PostMediaContainer = ({ post }: { post: Post }) => {
  const hasVideo = post.extraction.video.url != null;
  const platform = post.source.platform;
  const PlatformLogo = getPlatformLogo(platform);
  return (
    <div className="flex flex-col">
      {hasVideo ? (
        <PostMedia
          type="VIDEO"
          isSponsored={post.extraction.sponsored}
          videoSource={post.extraction.video.url!}
          posterUrl={post.extraction.video.poster_url}
          controls={true}
        />
      ) : (
        <PostMedia
          type="CAROUSEL"
          isSponsored={post.extraction.sponsored}
          posterUrl={post.extraction.video.poster_url}
        />
      )}
      <div className="flex justify-between px-4 py-2">
        <span className="text-muted-foreground text-sm font-normal">
          {new Date(post.date).toLocaleDateString('en-us', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
          })}
        </span>
        <PlatformLogo className="size-4" />
      </div>
    </div>
  );
};
